import React, { useEffect, useRef, useState } from 'react'
import './items-landing.styles.scss';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import ItemsList from './items-list.component';
import ItemsForm from './items-form.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { properCase } from '@/utils/properCase';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import ItemsUploadPage from './items-upload-page.component';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';
import { useEffectiveMembership } from '@/utils/useEffectiveMembership';

const ItemsLandingPage = ({
  gameElements,
  gameData,
  playerList,
  gameStats,
  role
}) => {

  const membership = useEffectiveMembership();
  const [showUpgradeModal, setShowUpgradeModal] = useState(null);
  const [itemsFromDb, setItemsFromDb] = useState(null);
  const [itemsRetrieved, setItemsRetrieved] = useState(false);
  const itemsRef = useRef();
  const location = useLocation(); 
  let itemsListener;
  const collectionsRef = useRef();
  let collectionsListener;
  const navigate = useNavigate();

  useEffect(() => {

    return () => {
      if (itemsListener) itemsListener();
      if (collectionsListener) collectionsListener();
    }
  }, [])

  useEffect(() => {
    if (!gameData || !membership) return;
    checkMembership();
  }, [membership, gameData]);

  useEffect(() => {
    if (!gameData || itemsRetrieved) return;
    getGameElementsToManage();
    // getCollectionsFromDb();
    setItemsRetrieved(true);
  }, [gameData])

  function checkMembership() {
    const element = 'items'
    const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'element': element })
    // console.log(res);

    if (res.disabled) {
      let message = ''
      const planRest = membershipRestrictions[membership.membership];
      if (res.disabledReason.includes(element)) {
        message = `While using the ${planRest.title}, you are not able to access ${properCase(element)}.`;
      }
      setShowUpgradeModal(message)
    }
  }

  function checkMembershipForNewItem(e) {
    const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'create': true });
    if (res.disabled && res.disabledReason.includes('elements')) {
      const planRest = membershipRestrictions[membership.membership];
      const message = `While using the ${planRest.title}, you are only able to have ${planRest.elementCount} active Game Elements per game.`;
      setShowUpgradeModal(message);
      return;
    }
    navigate('create');
  }

  function getGameElementsToManage() {
    if (location.pathname.includes('/preview/manager')) {
      const previewData = Object.values(completeGameElementData).filter(el => el.type === 'item');
      itemsRef.current = {};
      previewData.forEach(item => {
        itemsRef.current[item.id] = item;
      });
      setItemsFromDb(itemsRef.current);
      return;
    }
    console.log('getting items from Db')
    getCollectionFromDb({
      "collection": `games/${gameData.gameId}/gameElements`,
      "query1": {
        "key": "type",
        "condition": "==",
        "value": "item"
      },
      "query2": {
        "key": "opt_itemType",
        "condition": "!=",
        "value": "prizepack"
      },
      "callback": callback,
      "handleListener": handleListener
    })
    function callback(data) {
      itemsRef.current = {
        ...itemsRef.current,
        ...{ [data.id]: data }
      }
      setItemsFromDb(itemsRef.current);
    }
    function handleListener(data) {
      itemsListener = data;
    }
  }

  return (
    <div className='items-landing'>
      <Routes>
        <Route path='' element={
          <div className='g-card items-card'>
            <BackButton cancel={() => navigate(-1)} />
            <div className="g-space-1"></div>
            <div className='card-title'>
              <ImageContainer
                src='/images/icons/items.png'
                alt='items icon'
                className='head-icon'
              />
              Create and Edit Items
            </div>
            <hr />
            <div className='items-landing-content'>
              <ItemsList
                gameData={gameData}
                gameElements={gameElements}
                itemsFromDb={itemsFromDb}
                role={role} />
            </div>
          </div>
        }></Route>
        <Route path='upload' element={
          <ItemsUploadPage
            gameData={gameData}
            gameElements={gameElements}
            role={role}
          />
        }></Route>
        <Route path='create' element={
          <ItemsForm
            gameData={gameData}
            gameElements={gameElements}
            itemsFromDb={itemsFromDb}
            playerList={playerList}
            gameStats={gameStats}
            role={role} />
        }></Route>
        <Route path='edit/:itemPath' element={
          <ItemsForm
            gameData={gameData}
            gameElements={gameElements}
            itemsFromDb={itemsFromDb}
            playerList={playerList}
            gameStats={gameStats}
            role={role} />
        }></Route>
        <Route path="*" element={<Navigate replace to="/404" />} />
      </Routes>
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(null)}
        message={showUpgradeModal}
      />
    </div>
  )
}

export default ItemsLandingPage